/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PushNotification_admin = {|
  +allStudents: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +user: {|
          +id: string;
          +email: string;
        |};
        +firstname: ?string;
        +lastname: ?string;
      |};
    |}>;
  |};
  +allTutors: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +user: {|
          +id: string;
          +email: string;
        |};
        +firstname: ?string;
        +lastname: ?string;
      |};
    |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "firstStudents",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "searchStudent",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "firstTutors",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "searchTutor",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PushNotification_admin",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "firstStudents",
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "fuzzy",
          "variableName": "searchStudent",
          "type": "String"
        }
      ],
      "concreteType": "StudentConnection",
      "name": "allStudents",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "StudentEdge",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Student",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "email",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "firstname",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "lastname",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "firstTutors",
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "fuzzy",
          "variableName": "searchTutor",
          "type": "String"
        }
      ],
      "concreteType": "TutorConnection",
      "name": "allTutors",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TutorEdge",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "Tutor",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "email",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "firstname",
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "args": null,
                  "name": "lastname",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Admin"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/admin/__generated__/PushNotification_admin.graphql.js